import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FilterTableProvider from "@container/FilterTableProvider";
import { userColumns } from 'utils/recordHelpers'

const propTypes = {
  users: PropTypes.array.isRequired,
  newURL: PropTypes.string,
  locations: PropTypes.object,
  totalPages: PropTypes.number.isRequired,
  filterURL:  PropTypes.string.isRequired,
  tabs: PropTypes.array.isRequired,
  csvExportURL: PropTypes.string.isRequired,
};


class UsersIndexWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userColumns: userColumns,
      users: props.users,
      page: 1,
      totalPages: props.totalPages,
      loading: false,
      tabFilter: "all",
      selected: 0,
      userFilters: {
        role: ''
      }
    }
  }
  render() {
    const props = this.props;
    const {page, loading} = this.state;
    const primaryAction = this.props.newURL ? {
          content: I18n.t("actions.add_x", {x: I18n.t("activerecord.models.user.one")}),
          url: this.props.newURL
        }
        : null
    const secondaryAction = { content: "Exportar CSV", external: true, url: props.csvExportURL }
    return (
          <FilterTableProvider
            pageProps={{
              title: I18n.t("activerecord.models.user.other"),
              primaryAction: primaryAction,
              secondaryActions: [secondaryAction]
            }}
            searchName="search_query"
            paramsName="filters"
            filterURL= { props.filterURL }
            itemURL= { props.filterURL }
            tabs={ this.props.tabs }
            resourceTableProps={{
              itemURL: '/admin/users',
              urlAction: 'edit'
            }}
            initialFilters={{
              role: this.props.tabs[0].value,
              search_query: ''
            }}

            initialRecords={ props.users }
            columnsInfo={ this.state.userColumns }
            statusParamName="role"

            initialTotalPages={ props.totalPages }
            legacy={ false }
          >
          </FilterTableProvider>
    );
  }
}


UsersIndexWrapper.propTypes = propTypes;


export default UsersIndexWrapper;
